import { Box, Button, Chip, Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as AddSquare } from '../../../assets/icons/add-square-green.svg'
import { ReactComponent as Document } from '../../../assets/icons/document.svg'

import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import InputTextField from '../../../components/input/inputTextField';
import UploadFile from '../../../components/upload/UploadFile';
import { swalError, swalSuccess } from '../../../components/alert/swal';
import { formatFileSize, handleTypingNumber } from '../../../utils/app.utils';
import { ThesisProgressApi } from '../../../api/thesis-progress/thesis-progress.api';
// import ModalCustom from '../../../components/modal/ModalCustom';
import StepperCustom from '../../../components/step/Stepper';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import { THESIS_PROGRESS_STATUS, thesis_progress_step_data } from '../../students/thesis-progress/enum';
import TableCustom from '../../../components/table/tableCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import ModalCustom from '../../../components/modal/modalCustomCms';
import { useDropzone } from 'react-dropzone';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { THESIS_PROGRESS_STEP_ENUM } from './enum/enum';


const defaultState = {
    id_examination_calendar: 0,
    examination_name: '',
    examination_desc: '',
    examination_start_date: undefined,
    examination_end_date: undefined,
    examination_calendar_start_date: undefined,
    examination_calendar_end_date: undefined,
    examination_calendar_status: "DRAFT",
    id_examination_calendar_files: []
}
export default function AddThesisProgress() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const allStep: any[] = useMemo(() => [
        { name: t('ข้อมูลความคืบหน้า'), isAccept: true, icon: null, disabled: false },
        { name: t('การตอบกลับจากอาจารย์ที่ปรึกษา'), isAccept: true, icon: null, disabled: false },

    ], [t,]);

    const base_api_url = useSelector((state: RootState) => state.api.image_api);
    const location = useLocation();
    const pathname = location.pathname;
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    const mode = search_params.get("mode");
    const is_view = mode === 'VIEW';
    const { id, id_thesis_progress } = useParams();
    const [step, setStep] = useState<any>(0);

    const [remark, setRemark] = useState<string>('');
    const [files, setFiles] = useState<any[]>([]);
    const [open, setOpen] = useState<boolean>(false)
    const [openApprove, setOpenApprove] = useState<boolean>(false)
    const [form, setForm] = useState<any>(defaultState)
    const [formApprove, setFormApprove] = useState<any>();
    const [progress_data, set_progress_data] = useState<any[]>([]);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, _setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [approve_file, set_approve_file] = useState<{ file: any }[]>([]);


    // const handleUpdate = async (file: any, index: number) => {
    //     const formData = new FormData();

    //     //DRAFT
    //     formData.append("file", file[0]);

    //     await ThesisProgressApi.uploadProgress(formData).then((res: any) => {
    //         if (res.status < 300) {

    //             setFiles(files?.map((item: any, i: number) => {
    //                 return i === index ? res.data : item
    //             })
    //             )
    //         }
    //     }).catch((error: any) => {
    //         console.log(error)
    //         swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
    //     })
    // }
    const handleApprove = async (status: any) => {
        let id_thesis_progress_file: number[] = [];
        const id_thesis_progress_file_api: number[] = approve_file?.filter((x) => x?.file?.id_thesis_progress_file)?.map((list) => list?.file?.id_thesis_progress_file);
        if (approve_file?.length > 0) {
            const id_files = await handleUploadFile(approve_file?.filter((x) => x?.file).map((list) => list?.file));
            id_thesis_progress_file = [...id_thesis_progress_file, ...id_files]
        }
        if (id_thesis_progress_file_api?.length > 0) {
            id_thesis_progress_file = [...id_thesis_progress_file, ...id_thesis_progress_file_api];
        }
        const body = {
            thesis_progress_approve_status: status || "",
            thesis_progress_approve_remark: formApprove?.thesis_progress_approve_remark || "",
            // thesis_progress_approve_percent: status === 'APPROVE' ? formApprove?.thesis_progress_approve_percent : undefined,
            id_thesis_progress_approve_file: id_thesis_progress_file,
            thesis_progress_step: progress_data?.length > 0 ? progress_data?.map((list) => {
                const is_active = list?.status === 'active'
                return {
                    id_thesis_progress_step: list?.id_thesis_progress_step || null,
                    seq: list?.seq || null,
                    status: list?.status,
                    thesis_progress_step_name: list?.thesis_progress_step_name,
                    thesis_progress_step_status: (status === 'APPROVE' && is_active) ? THESIS_PROGRESS_STEP_ENUM.SUCCESS : THESIS_PROGRESS_STEP_ENUM.NOT_STARTED,
                    thesis_progress_step_percent: list?.thesis_progress_percent
                }
            }) : []
            // id_thesis_progress_approve_file: files?.map((item: any) => {
            //     return item?.id_thesis_progress_approve_file?.toString()
            // }) || ""
        }
        if (id) {
            dispatch(setLoading());
            await ThesisProgressApi.patch(body, id, id_thesis_progress).then((res: any) => {
                if (res.status < 300) {
                    setOpen(false);
                    swalSuccess(status === 'APPROVE' ? t('ผ่านการตรวจสอบ เรียบร้อยแล้ว') : t('พิจารณาไม่ผ่านการตรวจสอบ เรียบร้อยแล้ว'))
                    navigate(routeName.cms.ListThesisProgress.replace(':id', `${id}`));
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleDeleteFile = (index: number) => {
        setFiles((prev) => prev.filter((_, i) => i !== index))
    }

    const handleUploadFile = async (files: File[]): Promise<number[]> => {
        try {
            let id_thesis_progress_files = []
            const upload_promise = files?.map(async (file) => {
                const formData = new FormData();
                formData.append('file', file);
                return await ThesisProgressApi.uploadProgress(formData).then((res) => {
                    return res.data?.id_thesis_progress_approve_file
                })
            })

            id_thesis_progress_files = await Promise.all(upload_promise)

            if (id_thesis_progress_files?.length > 0) {
                return id_thesis_progress_files
            } else {
                return []
            }
        } catch (err) {
            console.log(err, 'err')
            return [];
        }
    }

    const getDetail = async () => {
        await ThesisProgressApi.findByIdThesisProgress(id, id_thesis_progress).then((res: any) => {
            if (res.status < 300) {
                const files_response: any[] = res.data?.data?.file || [];
                const approve_file: any[] = res.data?.data?.approve?.file_approve?.map((list: any) => ({ file: list })) || [];
                const thesis_progress_step: any[] = res.data?.data?.thesis_progress_step || [];
                if (thesis_progress_step?.length > 0) {
                    set_progress_data(thesis_progress_step)
                }
                if (approve_file?.length > 0) {
                    set_approve_file(approve_file);
                }
                if (files_response?.length > 0) {
                    setFiles(files_response);
                }
                setForm({ ...res.data.data, id_thesis_progress_file: res.data.data.file })
                setFormApprove({ ...formApprove, thesis_progress_approve_percent: res.data.data?.thesis_progress_percent })

                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }

    const onDrop = useCallback((acceptedFiles: File[]) => {
        const files = acceptedFiles?.map((list) => ({ file: list }))
        set_approve_file((prev) => ([...prev, ...files]))
    }, [])
    const { getRootProps, getInputProps } = useDropzone({
        multiple: true,
        onDrop, accept: {
            'application/pdf': ['.pdf'],
        }
    })
    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "left",
            label: is_view ? <div className='flex justify-start'>ไฟล์แนบ</div> : <div {...getRootProps()} className='flex justify-start items-center'>
                <input {...getInputProps()} />
                <Button sx={{ color: "white" }} startIcon={<AddSquare />}>ไฟล์แนบ</Button>
            </div>,
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "",
        },
    ];

    const renderData = (objData: any, no: any) => {
        const index = no;
        no = page * pageLimit - pageLimit + no + 1;
        const { id_thesis_progress, file_path, file_name, file, file_size } = objData;
        const is_instance_of_file = file instanceof File ? true : false
        const format_file_size = formatFileSize(file_size ? Number(file_size) : file?.size);
        // const file_date = moment().format("DD/MM/YY")

        const objRenderData = {
            key: id_thesis_progress,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "start",
                    label: `${file_name ? file_name : file?.name || ""} ${format_file_size}`,
                },
                {
                    option: "COMPONENT",
                    align: "end",
                    component: (
                        <div className='flex justify-end items-center'>
                            <OptionsButtonCustom
                                enableView
                                enableDelete={!is_view}
                                onViewClick={() => {
                                    if (is_instance_of_file) {
                                        window.open(URL.createObjectURL(file), '_blank')
                                    } else {
                                        window.open(`${base_api_url}/${file_path}${file_name}`)
                                    }
                                }}

                                onDeleteClick={() => {
                                    handleDeleteFile(index)
                                }}

                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };



    useEffect(() => {
        if (id) {
            getDetail()
        }

    }, [])

    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์"),
                        key: "1",
                        pathName: routeName.cms.EThesisProgress,
                    },
                    {
                        name: t("ข้อมูลความคืบหน้า"),
                        key: "2",
                        pathName: routeName.cms.ListThesisProgress,
                    },
                    {
                        name: t("รายละเอียด"),
                        key: "3",
                        pathName: pathname
                    },

                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">รายละเอียด</Typography>
            </section>
            {form?.thesis_progress_status !== 'WAITING' && mode === 'VIEW' &&
                <section className='w-full max-w-fit m-auto'>
                    <StepperCustom
                        sx={{ maxWidth: "fit-content" }}
                        step={step}
                        setStep={(num: number) => {
                            // dispatch(setStep(num));
                            setStep(num)
                        }}
                        view
                        stepLabel={allStep}
                    // view={is_accept}
                    />
                </section>}
            {step === 0 &&
                <section className="my-4">
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('ชื่อวิทยานิพนธ์')}
                                placeholder={t('ชื่อวิทยานิพนธ์')}
                                required
                                value={form?.thesis_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, thesis_name: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                disabled

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('รายละเอียด')}
                                placeholder={t('รายละเอียด')}
                                value={form?.thesis_progress_desc || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, thesis_progress_desc: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                disabled
                                multiline
                                minRow={6}
                                inputHeight={'auto'}
                            />
                        </Grid>
                        {/* <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('เปอร์เซ็นต์ความคืบหน้า')}
                                placeholder={t('เปอร์เซ็นต์ความคืบหน้า')}
                                value={form?.thesis_progress_percent || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, thesis_progress_percent: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                onkeypress={handleTypingNumber}
                                disabled
                                required
                            />
                        </Grid> */}


                    </Grid>

                    <Box my={2}>
                        <Typography my={1} variant='h5'>
                            ความคืบหน้า
                        </Typography>
                        {progress_data?.map((list, index) => {
                            return (
                                <Box key={index + 1} className="grid grid-cols-12 gap-4">
                                    <span className='col-span-12 md:col-span-3 xl:col-span-3'>
                                        <CheckBoxCustom
                                            checked={list?.status === THESIS_PROGRESS_STATUS.ACTIVE}
                                            disabled={progress_data[index - 1]?.status !== THESIS_PROGRESS_STATUS.ACTIVE && index !== 0 || is_view}
                                            setChecked={() => { }}
                                            label={`${list?.seq || ""}.${list?.thesis_progress_step_name || ""}`}
                                        />
                                    </span>
                                    <span className='col-span-12 md:col-span-3 xl:col-span-3'>
                                        {list?.thesis_progress_percent || list?.thesis_progress_step_percent || "-"} %
                                    </span>
                                    <span className='col-span-12 md:col-span-3 xl:col-span-3'>
                                        <Chip
                                            color={list?.thesis_progress_step_status === THESIS_PROGRESS_STEP_ENUM.SUCCESS ? "success" : undefined}
                                            label={thesis_progress_step_data?.find((x) => x?.value === list?.thesis_progress_step_status)?.label || ""}
                                        />
                                    </span>
                                </Box>
                            )
                        })}
                    </Box>
                    {/* 
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                        <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                    </div>
                    {form?.id_thesis_progress_file?.map((item: any, index: number) => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

                                {item?.file_name ?
                                    <div style={{
                                        border: "2px dotted #C1C3C7",
                                        borderRadius: "10px",
                                        padding: "15px 15px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <Document />
                                            <div style={{ display: "flex", alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                                            </div>
                                        </div>

                                        <ButtonOutlined
                                            onClick={() => {
                                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                                            }}
                                            buttonName={t('MEETING.DOWNLOAD_FILE')}
                                            btnProps={{
                                                width: "150px",
                                            }}
                                        />
                                    </div> :
                                    <UploadFile
                                        onDrop={(file) => {
                                            handleUpdate(file, index);
                                        }}
                                        onDeleteFile={() => {
                                        }}
                                        noClick={false}

                                    />}

                            </div>
                        )
                    })} */}

                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                files?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            hidePagination
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                </section>}

            {step === 1 &&
                <section className="my-4">
                    <Grid container spacing={2}>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('หมายเหตุ')}
                                placeholder={t('หมายเหตุ')}
                                value={form?.approve?.thesis_progress_approve_remark || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled
                                multiline
                                minRow={6}
                                inputHeight={'auto'}
                            />
                        </Grid>
                        {/* {form?.approve?.thesis_progress_approve_status !== 'REJECT' && <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('เปอร์เซ็นต์ความคืบหน้า')}
                                placeholder={t('เปอร์เซ็นต์ความคืบหน้า')}
                                value={form?.approve?.thesis_progress_approve_percent || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                onkeypress={handleTypingNumber}
                                disabled
                            />
                        </Grid>} */}


                    </Grid>

                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                form?.approve?.file_approve?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            hidePagination
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                        <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                    </div>
                    {form?.approve?.file_approve?.map((item: any, index: number) => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

                                {item?.file_name ?
                                    <div style={{
                                        border: "2px dotted #C1C3C7",
                                        borderRadius: "10px",
                                        padding: "15px 15px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <Document />
                                            <div style={{ display: "flex", alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                                            </div>
                                        </div>

                                        <ButtonOutlined
                                            onClick={() => {
                                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                                            }}
                                            buttonName={t('MEETING.DOWNLOAD_FILE')}
                                            btnProps={{
                                                width: "150px",
                                            }}
                                        />
                                    </div> :
                                    <UploadFile
                                        onDrop={(file) => {
                                            handleUpdate(file, index);
                                        }}
                                        onDeleteFile={() => {

                                        }}
                                        noClick={false}
                                    />}

                            </div>
                        )
                    })} */}
                </section>}

            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        // navigate(routeName.cms.MeetingCalendar);
                        navigate(routeName.cms.ListThesisProgress.replace(':id', `${id}`));
                    }}
                    buttonName="ย้อนกลับ"
                    btnProps={{
                        width: "150px",
                    }}
                />


                {mode !== 'VIEW' && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        // handleApprove()
                        setOpenApprove(true)
                    }}
                    mode="success"
                    buttonName="ผ่าน"
                    btnProps={{
                        width: "150px",
                    }}
                />}
                {mode !== 'VIEW' && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        setOpen(true)
                    }}
                    mode="success"
                    buttonName="ไม่ผ่าน"
                    btnProps={{
                        width: "150px",
                        bg: 'red'
                    }}
                />}
            </section>
            <ModalCustom maxWidth='lg' onClick={() => {
                handleApprove('REJECT');
            }} handleClose={() => {
                setOpen(false)
                setRemark('')
            }} title={t('ไม่ผ่านการตรวจสอบ')} subTitle={t('กรุณาระบุหมายเหตุเพื่อทำการยืนยัน')} open={open} form={
                <div className='flex flex-col gap-4 w-full'>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('หมายเหตุ')}
                            placeholder={t('หมายเหตุ')}
                            required
                            value={formApprove?.thesis_progress_approve_remark || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setFormApprove({ ...formApprove, thesis_progress_approve_remark: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            inputHeight={'auto'}
                            minRow={6}
                            multiline
                        />

                    </article>


                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                approve_file?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            hidePagination
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                        <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                        <AddSquare onClick={() => setFiles(files?.length > 0 ? [...files, {}] : [{}])} />
                    </div>
                    {files?.map((item: any, index: number) => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>
                                {item?.file_name ?
                                    <div style={{
                                        border: "2px dotted #C1C3C7",
                                        borderRadius: "10px",
                                        padding: "15px 15px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <Document />
                                            <div style={{ display: "flex", alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                                            </div>
                                        </div>

                                        <ButtonOutlined
                                            onClick={() => {
                                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                                            }}
                                            buttonName={t('MEETING.DOWNLOAD_FILE')}
                                            btnProps={{
                                                width: "150px",
                                                // border: '#0F9F0C'
                                            }}
                                        />
                                    </div> :
                                    <UploadFile
                                        onDrop={(file) => {
                                            handleUpdate(file, index);
                                        }}
                                        onDeleteFile={() => {
                                        }}
                                        noClick={false}
                                    />}
                                <div style={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '8px',
                                    padding: '16px',
                                }}>
                                    <Bag />
                                </div>
                            </div>
                        )
                    })} */}
                    {/* <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                                setRemark('')

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        <ButtonPrimary
                            onClick={() => {

                                setOpen(false)
                                handleApprove('REJECT')
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                            btnProps={{
                                bg: 'red'
                            }}
                        />
                    </div> */}
                </div>
            } />
            <ModalCustom maxWidth='lg' onClick={() => {
                setOpenApprove(false);
                handleApprove('APPROVE');
            }} handleClose={() => {
                setOpenApprove(false)
            }} title={t('ผ่านการตรวจสอบ')} subTitle={t('กรุณาระบุหมายเหตุเพื่อทำการยืนยัน')} open={openApprove} form={
                <div className='flex flex-col gap-4 w-full'>
                    <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('หมายเหตุ')}
                            placeholder={t('หมายเหตุ')}
                            required
                            value={formApprove?.thesis_progress_approve_remark || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setFormApprove({ ...formApprove, thesis_progress_approve_remark: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            inputHeight={'auto'}
                            minRow={6}
                            multiline
                        />


                    </article>

                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                approve_file?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            hidePagination
                            onSort={() => { }}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>
                    {/* <article className="w-full col-span-12 md:col-span-4 lg:col-span-2 sm:col-span-12">
                        <InputTextField
                            heading={t('เปอร์เซ็นต์ความคืบหน้า')}
                            placeholder={t('เปอร์เซ็นต์ความคืบหน้า')}
                            required
                            value={formApprove?.thesis_progress_approve_percent || ''}
                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                setFormApprove({ ...formApprove, thesis_progress_approve_percent: e.target.value })
                            }}
                            helperText={
                                ""
                            }
                            onkeypress={handleTypingNumber}
                        />

                    </article> */}

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                        <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                        <AddSquare onClick={() => setFiles(files?.length > 0 ? [...files, {}] : [{}])} />
                    </div>
                    {files?.map((item: any, index: number) => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

                                {item?.file_name ?
                                    <div style={{
                                        border: "2px dotted #C1C3C7",
                                        borderRadius: "10px",
                                        padding: "15px 15px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <Document />
                                            <div style={{ display: "flex", alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                                            </div>
                                        </div>

                                        <ButtonOutlined
                                            onClick={() => {
                                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                                            }}
                                            buttonName={t('MEETING.DOWNLOAD_FILE')}
                                            btnProps={{
                                                width: "150px",
                                            }}
                                        />
                                    </div> :
                                    <UploadFile
                                        onDrop={(file) => {
                                            handleUpdate(file, index);
                                        }}
                                        onDeleteFile={() => {
                                        }}
                                        noClick={false}

                                    />}
                                <div style={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '8px',
                                    padding: '16px',
                                }}>
                                    <Bag />
                                </div>
                            </div>
                        )
                    })} */}
                    {/* <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpenApprove(false)

                            }}
                            buttonName={'ยกเลิก'}
                        />
                        <ButtonPrimary
                            onClick={() => {

                                setOpenApprove(false)
                                handleApprove('APPROVE')
                            }}
                            mode='add'
                            buttonName={'ยืนยัน'}
                            btnProps={{
                            }}
                        />
                    </div> */}
                </div>
            } />
        </div>
    )
}
